import React from "react";
import { FaInstagram, FaWhatsapp } from "react-icons/fa";
import jalaali from 'jalaali-js';

const Footer = () => {


  const getPersianYear = () => {
    const gregorianDate = new Date();
    const { jy } = jalaali.toJalaali(gregorianDate);
    return jy.toString().replace(/\d/g, (d) => '۰۱۲۳۴۵۶۷۸۹'[d]);
  };

  return (
    <footer className="bg-neutral-950 text-white px-6 py-10 text-sm">
      <div dir="rtl" className="max-w-screen-xl mx-auto grid grid-cols-2 md:grid-cols-5 gap-8">
        {/* About Section */}
        <div className="hidden md:flex md:flex-col">
          <h4 className="text-lg font-semibold mb-4 tracking-wide bg-gradient-to-r from-[#FF8C42] via-[#FF6F00] to-[#D18F00] text-transparent bg-clip-text">درباره ما</h4>
          <p className="text-gray-400 leading-6">
            ما با عشق به قهوه، بهترین دانه‌ها را انتخاب می‌کنیم تا تجربه‌ای خاص به شما ارائه دهیم.
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="text-lg font-semibold mb-4 tracking-wide bg-gradient-to-r from-[#FF8C42] via-[#FF6F00] to-[#D18F00] text-transparent bg-clip-text">لینک‌های سریع</h4>
          <ul className="space-y-2 text-gray-300">
            <li><a href="/" className="hover:text-white transition">صفحه اصلی</a></li>
            {/* <li><a href="/products" className="hover:text-white transition">محصولات</a></li> */}
            <li><a href="/about" className="hover:text-white transition">درباره ما</a></li>
            <li><a href="/contact-us" className="hover:text-white transition">تماس با ما</a></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div>
          <h4 className="text-lg font-semibold mb-4 tracking-wide bg-gradient-to-r from-[#FF8C42] via-[#FF6F00] to-[#D18F00] text-transparent bg-clip-text">تماس با ما</h4>
          <ul className="space-y-2 text-gray-300">
            <li className="flex items-center gap-3">
              <a href="https://wa.me/989155838178" target="_blank" rel="noopener noreferrer" aria-label="Whatsapp" className="hover:text-white transition flex items-center gap-1">
                <FaWhatsapp />
                <span>
                  ۰۹۱۵۵۸۳۷۱۸۷
                </span>
              </a>

            </li>
            <li className="md:w-64">
              <a href="mailto:khorasanianr@yahoo.com">
                ایمیل: khorasanianr@yahoo.com
              </a>
            </li>
          </ul>
        </div>

        {/* Social Media */}
        <div>
          <h4 className="text-lg font-semibold mb-4 text-neonOrange">ما را دنبال کنید</h4>
          <div className="flex gap-4 text-xl text-gray-300">
            <a href="https://www.instagram.com/srsroast/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="hover:text-white transition flex items-center gap-1 text-sm"><FaInstagram />SRSRosat</a>
          </div>
        </div>

        {/* Secure Sign */}
        <div>
          <h4 className="text-lg font-semibold mb-4 text-neonOrange">نمادهای اعتماد</h4>
          <div className="flex gap-4 text-xl text-gray-300 justify-between">
            {/* eslint-disable-next-line react/jsx-no-target-blank */}
            <a
              referrerPolicy='origin'
              target='_blank'
              href='https://trustseal.enamad.ir/?id=7399231&Code=P8UO4kjWJvnHMpJ8xcOTyC4kpxU4OphO'>
              <img referrerPolicy='origin'
                src='https://trustseal.enamad.ir/logo.aspx?id=7399231&Code=P8UO4kjWJvnHMpJ8xcOTyC4kpxU4OphO'
                alt=''
                style={{ cursor: 'pointer', }}
                className="md:w-28 md:h-28 w-20 h-20"
                code='P8UO4kjWJvnHMpJ8xcOTyC4kpxU4OphO' />
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-gray-700 mt-10 pt-6 text-center text-gray-500 text-xs" dir="rtl">
        <p>© {getPersianYear()} سیلک‌رود سان. تمامی حقوق محفوظ است.</p>
      </div>
    </footer>
  );
};

export default Footer;
